import React, { createElement } from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import EmOverTimePresenter from "./EmOverTimePresenter";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import withRouter from "../../../withRouter";
import GenerateCOC from "./Generate/GenerateCOC";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import RequestOvertime from "../../EmployeeSelfService/Overtime/RequestOvertime/RequestOvertime";
import DateRangePicker from "../../../components/common/DateRangePicker";
import Progress from "../../../components/Progress";
class EmOverTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new EmOverTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      isModalOpen: false,
      isGenerate: false,
      objects: [],
      filteredStatus: "",
      status: [],
      object: {},
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const status = await findObjectUseCase().execute("overtime");
    this.setState({ status });
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "filteredStatus") {
      this.onChangeFilter("String", value, "stats");
    }
  }

  getCollectionName() {
    return "overtime";
  }

  // delete function
  // async handleDeleteData(id) {
  //   await this.presenter.deleteObjectUseCase.execute("overtime", id);
  //   this.refetchData();
  // }

  // edit function
  async handleEditData(object) {
    // this.navigateTo(`/collection/${this.getCollectionName()}/form/${id}`);

    this.setState({ isModalOpen: true, object, isAdmin: true });
  }

  handleRequestOvertime() {
    this.setState({ isModalOpen: true, object: {} });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  GenerateCOC() {
    this.setState({ isGenerate: true });
  }

  closeGenerate() {
    this.setState({ isGenerate: false });
  }

  // GenerateExcel() {
  //   alert("Excel");
  // }
  GenerateCSV() {
    alert("CSV");
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  getcurrent() {
    return this.getCurrentUser().employee;
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    const user = this.getCurrentUser().username;

    const predefinedStatus = ["Pending", "Approved", "Rejected"];
    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Human Resource {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>

              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-2">
                    <SearchSelect
                      value={this.state.filteredStatus}
                      onChange={(value) =>
                        this.onChangeOption("filteredStatus", value)
                      }
                      onClickClear={() =>
                        this.onChangeOption("filteredStatus", "")
                      }
                      placeholder="Status"
                      options={[
                        ...predefinedStatus.map((stats) => ({
                          label: stats,
                          value: stats,
                        })),
                      ]}
                    />
                  </div>
                  <div className="col-md-5">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-md-5">
                    <DateRangePicker
                      fields={["dateStarted", "dateEnd", "employee.id"]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      style={{ marginLeft: "auto", display: "flex", gap: 3 }}
                    >
                      {/* <Button onClick={this.GenerateCOC.bind(this)}>
                        <i className="bi bi-file-earmark-break" /> Generate COC
                      </Button> */}
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        // onClick={this.GeneratePDF.bind(this)}
                        onClick={() => this.presenter.GeneratePDF(user)}
                      >
                        <i className="bi bi-filetype-pdf" /> PDF
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateExcel()}
                      >
                        <i className="bi bi-filetype-exe" /> Excel
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateExcel()}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // empPointer={empPointer}
                // objectId={this.handleDeleteData.bind(this)}
                objectData={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "remarks",
                    "timeIn",
                    "timeOut",
                    "dateEnd",
                    "dateStarted",
                    "supervisor",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>

          {this.state.isModalOpen && (
            <RequestOvertime
              object={this.state.object}
              isAdmin={this.state.isAdmin}
              closeAccess={this.closeModal.bind(this)}
              refetchData={this.refetchData.bind(this)}
            />
          )}

          {this.state.isGenerate && (
            <GenerateCOC closeAccess={this.closeGenerate.bind(this)} />
          )}
        </div>
      </>
    );
  }
}

export default withRouter(EmOverTimePage);
